import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Lucía', 'Matías', 'Sofía', 'Joaquín', 'Valentina', 'Santiago', 'Camila', 'Tomás', 'Florencia', 'Agustín', 'Martina', 'Federico', 'Julián', 'Micaela', 'Nicolás', 'Antonella'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Corrientes'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimeout = setTimeout(showPopup, 5000);
    // Loop
    const interval = setInterval(() => {
      // Random interval between 8-12 seconds + 4 seconds display time
      const randomDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showPopup, randomDelay);
    }, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-254">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl p-4 max-w-xs border-l-4 border-green-500 flex items-start gap-3" data-id="element-255">
          <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-256">
            <CheckCircle className="w-6 h-6 text-green-600" data-id="element-257" />
          </div>
          <div data-id="element-258">
            <p className="text-sm font-bold text-gray-900" data-id="element-259">
              🔥 {data.name} de {data.city}
            </p>
            <p className="text-xs text-gray-600 mt-1" data-id="element-260">
              acaba de comprar el{' '}
              <span className="font-semibold" data-id="element-261">Mega Pack</span>
            </p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-262">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}